export default "__VITE_PUBLIC_ASSET__8e807060__"